var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-header",class:{ 'at-home': _vm.atHome, 'nav-shrink': _vm.shrink }},[_c('AppNav'),(_vm.alert.show)?_c('AppAlert',{attrs:{"type":_vm.alert.type,"message":_vm.alert.message}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }